import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import { NavDropdown } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import messages from '../../locale/messages';
import { useDispatch, useSelector } from 'react-redux';
import { formatLocale } from '../../helpers/formatLocale';

import NavLink from '../NavLink';
import NavigationAfterLogin from '../Navigations/NavigationAfterLogin/NavigationAfterLogin';

import history from '../../history';
import { DropDownHamburgIcon, HomeSvgIcon } from '../Common/Assets/SVGIcon/CommonSvgIcon';
import { AdminHeaderDarkModeIcon, AdminHeaderLanguageIcon, AdminHeaderLightModeIcon } from '../Common/Assets/SVGIcon/AdminHeaderIcon';
import { api, profilePhotouploadDir } from '../../config';

import { getOrder } from '../../lib/graphql';
import useQueryResponse from '../../lib/hooks/useQueryResponse';

import defaultPic from '/public/dashboard/defaultIconMenu.svg';
import s from './Header.css';


const HeaderSideList = (props) => {
    const { handleThemeChange, openLoginModal, handleLanguageChange, containerClass, handleMenuClose } = props;
    const { socket } = props;
    const currentLocale = useSelector(state => state.intl.locale);
    const selectedTheme = useSelector(state => state.currency.theme);
    const isAuthenticated = useSelector(state => state.runtime.isAuthenticated);
    const profileImage = useSelector(state => state?.userAccount?.data?.picture)
    const userLogout = useSelector((state) => state.adminModalStatus.userLogout)
    const [location, setLocation] = useState('');
    const intl = useIntl()
    const dispatch = useDispatch();

    const redirectSearch = () => {
        history.push('/category?type=all');
        handleMenuClose();
    }

    useEffect(() => {
        if (history.location) {
            setLocation(history.location.pathname);
        }
    }, [history.location]);

    const { data, loading, refetch } = useQueryResponse({
        query: getOrder,
        variables: { promoId: null },
        ssr: false,
        fetchPolicy: 'network-only'
    });

    useEffect(() => {
        if (!socket) return;

        const orderId = data?.getOrder?.result?.id;
        const handler = () => refetch();

        const event = `removeOrdersUpdated-${orderId || 'none'}`;
        socket.on(event, handler);

        return () => socket.off(event, handler);

    }, [socket, data?.getOrder?.result?.id, refetch]);


    let picture = profileImage ? api.apiEndpoint + profilePhotouploadDir + 'medium_' + profileImage : defaultPic;

    return (
        <div className={cx(containerClass, 'hidden-print')}>
            <NavDropdown
                title={
                    <span className={cx(s.headerMenuList, s.adminHeaderDropdownMenuItem)}>
                        {selectedTheme === 'light' && <AdminHeaderLightModeIcon className={s.headerMenuItemIcon} />}
                        {selectedTheme === 'dark' && <AdminHeaderDarkModeIcon className={s.headerMenuItemIcon} />}
                        <span className={s.homeHeaderMenuText}>
                            {selectedTheme === 'light' && <FormattedMessage {...messages.lightMode} />}
                            {selectedTheme === 'dark' && <FormattedMessage {...messages.darkMode} />}
                        </span>
                    </span>
                }
                id="basic-nav-dropdown1"
                className={cx("adminHeaderDropdownMenu", s.headerListMobileHidden)}
            >
                <NavDropdown.Item to="#" onClick={() => handleThemeChange('light')}>
                    <div className={cx(s.headerDropDownInnerList, selectedTheme === 'light' && s.headerDropDownInnerListActive)}>
                        <AdminHeaderLightModeIcon className={s.headerMenuItemIcon} />
                        <FormattedMessage {...messages.lightMode} />
                    </div>
                </NavDropdown.Item>

                <NavDropdown.Item to="#" onClick={() => handleThemeChange('dark')}>
                    <div className={cx(s.headerDropDownInnerList, selectedTheme === 'dark' && s.headerDropDownInnerListActive)}>
                        <AdminHeaderDarkModeIcon className={s.headerMenuItemIcon} />
                        <FormattedMessage {...messages.darkMode} />
                    </div>
                </NavDropdown.Item>
            </NavDropdown>

            <NavLink to="#" onClick={() => handleThemeChange('light')} className={cx(s.headerMenuList, s.headerListWebHidden)}>
                <AdminHeaderLightModeIcon className={s.headerMenuItemIcon} />
                <FormattedMessage {...messages.lightMode} />
            </NavLink>

            <NavLink to="#" onClick={() => handleThemeChange('dark')} className={cx(s.headerMenuList, s.headerListWebHidden)}>
                <AdminHeaderDarkModeIcon className={s.headerMenuItemIcon} />
                <FormattedMessage {...messages.darkMode} />
            </NavLink>

            <NavLink noLink onClick={handleLanguageChange} className={s.headerMenuList}>
                <AdminHeaderLanguageIcon className={s.headerMenuItemIcon} />
                <span>
                    {formatLocale(currentLocale)}
                </span>
            </NavLink>

            <NavLink to="/" className={cx(s.headerMenuList, ((location === '/' || location === '/home') && s.activeListMenu))} onClick={handleMenuClose}>
                <HomeSvgIcon className={s.headerMenuItemIcon} />
                <FormattedMessage {...messages.homeonly} />
            </NavLink>

            {isAuthenticated && <div className={cx(s.headerListWebHidden, s.headerMobileListContainer)}> <NavigationAfterLogin handleMenuClose={handleMenuClose} orderId={data?.getOrder?.result?.id} /></div>}
            {isAuthenticated && <div className='d-flex'>
                <NavLink noLink onClick={redirectSearch} className={s.homeHeaderBtn}>
                    <FormattedMessage {...messages.bookNow} />
                </NavLink>
            </div>}
            {!isAuthenticated ? (
                <button
                    onClick={(e) => openLoginModal()}
                    className={s.homeHeaderBtn}
                >
                    <FormattedMessage {...messages.loginSignupLabel} />
                </button>
            ) : (
                <NavDropdown
                    title={
                        <>
                            <div className={s.headerNavLogoContainer}>
                                <img src={picture} alt="toggleMenuIcon" />
                            </div>
                            <div className={cx(s.headerNavLogoHamburg, 'headerNavLogoHamburgRTL')}>
                                <DropDownHamburgIcon />
                            </div>
                        </>
                    }
                    className={cx("headerAfterNavigationButtonContainer", s.headerListMobileHidden)}
                    id="user-dropdown"
                >
                    <NavigationAfterLogin afterDropdown orderId={data?.getOrder?.result?.id} />
                </NavDropdown>
            )}
        </div>
    )
}

export default withStyles(s)(HeaderSideList);